"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopulistsPolicy3Action = void 0;
const TurmoilActionCard_1 = require("../../TurmoilActionCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Populists_1 = require("../../../turmoil/parties/Populists");
class PopulistsPolicy3Action extends TurmoilActionCard_1.TurmoilActionCard {
    constructor() {
        super({
            name: CardName_1.CardName.POPULISTS_POLICY_3_ACTION,
            metadata: {
                cardNumber: 'TA13',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject(Populists_1.POPULISTS_POLICY_3.description, (eb) => {
                    eb.tr(1).startAction.cards(2).asterix();
                })),
            },
        });
    }
    canAct(player) {
        return Populists_1.POPULISTS_POLICY_3.canAct(player);
    }
    action(player) {
        return Populists_1.POPULISTS_POLICY_3.action(player);
    }
}
exports.PopulistsPolicy3Action = PopulistsPolicy3Action;
//# sourceMappingURL=PopulistsPolicy3Action.js.map